import { html } from 'lit';

/**
 * @param {import('../navbar.js').default} el
 */
export default (el) => {
    return html`<nav class="navbar navbar-expand-lg"><div class="container-fluid"><div class="collapse navbar-collapse"><ul class="navbar-nav ms-auto mb-2 mb-lg-0"><li class="nav-item"><a class="nav-link" target="_blank" rel="noopener" href="https://mnor.sbs:5282/apk/Taskino-2.8.11.34.6.apk">Android</a></li><li class="nav-item"><a class="nav-link" target="_blank" rel="noopener" href="#">IOS</a></li><li class="nav-item"><a class="nav-link" target="_blank" rel="noopener" href="#">Contact</a></li><li class="nav-item"><a class="nav-link" target="_blank" rel="noopener" href="#">FAQ</a></li></ul></div></div></nav>`;
};
